import { __rest } from "tslib";
import * as React from 'react';
import Input from '../../../../Input';
import { useDynamicInputMask } from './hooks';
const CodeInput = (_a) => {
    var { dynamicInputMask = false } = _a, props = __rest(_a, ["dynamicInputMask"]);
    const { value: textFieldValue, onChange } = props.TextFieldProps;
    const value = props.value || textFieldValue;
    const inputMaskProps = useDynamicInputMask({ value, onChange, enabled: dynamicInputMask });
    return (React.createElement(Input, Object.assign({}, props, { value: inputMaskProps.value, TextFieldProps: Object.assign(Object.assign({}, props.TextFieldProps), inputMaskProps) })));
};
export default CodeInput;
